import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-196" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-197" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center text-[1.75rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.4rem]" data-id="element-198" data-mp="3fyvxs9ef7bak">
          What Teachers Are Saying
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-stone-700" data-id="element-199" data-mp="36yzeknasv4mw">
          <span aria-hidden="true" data-id="element-200" data-mp="36wwf7cnrbz5i">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +1,500 Teachers & Trainers
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-2" data-id="element-201" data-mp="321z9ofpos7xd">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-stone-100 p-6" data-id="element-202" data-mp="2s1q8sokr1ybn">
              <div className="text-sm text-amber-500" aria-label="5 out of 5 stars" data-id="element-203" data-mp="v8dkrjstq8bc">
                <span aria-hidden="true" data-id="element-204" data-mp="qb4z398gvm5c">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 text-sm italic leading-relaxed text-stone-800" data-id="element-205" data-mp="h55ai23t7vx3">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-206" data-mp="78aatfvsvph8">
                <p className="text-xs font-bold text-stone-900" data-id="element-207" data-mp="79bqjxnrh05a">{item.name}</p>
                <p className="text-xs text-stone-500" data-id="element-208" data-mp="c7wry0er1pvb">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-stone-400" data-id="element-209" data-mp="zysdwgwixqun">
          Illustrative placeholder testimonials.
        </p>
      </div>
    </section>;
}